module.exports = "<fm-layout></fm-layout>\r\n\r\n"